import listTemplate from './views/pages/list.tpl.html';
import detailsTemplate from './views/pages/details.tpl.html';
import smsDetailsTemplate from './views/pages/sms/details.tpl.html';
import smsListTemplate from './views/pages/sms/list.tpl.html';
import smsTemplatesListTemplate from './views/pages/sms/templates/list.tpl.html';
import smsTemplatesEditorPageTemplate from './views/pages/sms/templates/editor.tpl.html';
import MessageDetailsPageController from './controllers/pages/details';
import MessagesListPageController from './controllers/pages/list';
import SmsDetailsPageController from './controllers/pages/sms/details';
import SmsListPageController from './controllers/pages/sms/list';
import SmsTemplatesListPageController from './controllers/pages/sms/templates/list';
import SmsTemplatesCreatePageController from './controllers/pages/sms/templates/create';
import SmsTemplatesEditPageController from './controllers/pages/sms/templates/edit';

angular
    .module('festzelt-os.modules.messages')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.messages', {
            abstract: true,
            url: '/messages',
            template: '<ui-view/>'
        })
        .state('app.messages.index', {
            url: '',
            params: {},
            data: {
                rights: 'messages::list'
            },
            controller: MessagesListPageController,
            controllerAs: 'vm',
            templateUrl: listTemplate
        })
        .state('app.messages.details', {
            url: '/{id}',
            params: {
                id: {
                    type: 'int'
                },
                store: {
                    type: 'any',
                    default: null
                }
            },
            data: {
                rights: 'messages::view'
            },
            controller: MessageDetailsPageController,
            controllerAs: 'vm',
            templateUrl: detailsTemplate
        })
        .state('app.messages.sms', {
            abstract: true,
            url: '/sms',
            template: '<ui-view/>'
        })
        .state('app.messages.sms.index', {
            url: '',
            params: {},
            data: {
                rights: 'messages::list-sms'
            },
            controller: SmsListPageController,
            controllerAs: 'vm',
            templateUrl: smsListTemplate
        })
        .state('app.messages.sms.details', {
            url: '/{id}',
            params: {
                id: {
                    type: 'int'
                },
                store: {
                    type: 'any',
                    default: null
                }
            },
            data: {
                rights: 'messages::view'
            },
            controller: SmsDetailsPageController,
            controllerAs: 'vm',
            templateUrl: smsDetailsTemplate
        })
        .state('app.messages.sms.templates', {
            abstract: true,
            url: '/templates',
            template: '<ui-view/>'
        })
        .state('app.messages.sms.templates.index', {
            url: '',
            params: {},
            data: {
                rights: 'messages::sms-template-list'
            },
            controller: SmsTemplatesListPageController,
            controllerAs: 'vm',
            templateUrl: smsTemplatesListTemplate
        })
        .state('app.messages.sms.templates.create', {
            url: '/create',
            params: {},
            data: {
                rights: 'messages::sms-template-create'
            },
            controller: SmsTemplatesCreatePageController,
            controllerAs: 'vm',
            templateUrl: smsTemplatesEditorPageTemplate
        })
        .state('app.messages.sms.templates.edit', {
            url: '/{id}/edit',
            params: {
                id: {
                    type: 'int'
                }
            },
            data: {
                bodyClass: 'wide',
                rights: 'messages::sms-template-edit'
            },
            controller: SmsTemplatesEditPageController,
            controllerAs: 'vm',
            templateUrl: smsTemplatesEditorPageTemplate
        })
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/routes.js